import * as React from "react";
import { Helmet } from "react-helmet-async";
import layoutStyles from "./PublicLayout.module.css";

type PublicLayoutProps = {
  children: React.ReactNode;
};

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <>
      {/*
        No <title> here: PublicLayout is shared (Pay Invoice, Compliance Guide AI
        Assistant, Compliance Guide Signup). WithLayout sets document.title per route
        from its PageTitle prop, so a hardcoded title here would override every page
        with the wrong name.
      */}
      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
          rel="stylesheet"
        />
      </Helmet>

      <div className={layoutStyles.publicLayout}>
        <div className={layoutStyles.mainContent}>{children}</div>
      </div>
    </>
  );
};

export default PublicLayout;
